import { useEffect, useState } from 'react';
import { Input } from 'antd';
import { notification } from 'antd';

import { FEATURE_FLAG_NAMES } from '@rockalingua/shared/featureFlags/constants';
import useFeatureFlag from '@/v2/domains/FeatureFlags/hooks/useFeatureFlag.hook';
import appStorage from '@/modules/storage/appStorage';

import { StyledEnvironmentWall } from './EnvironmentWall.styled';
import Button from '../Button/Button';

export default function EnvironmentWall() {
  const [showWall, setShowWall] = useState(false);
  const [value, setValue] = useState('');
  const isEnvironmentWallEnabled = useFeatureFlag(
    FEATURE_FLAG_NAMES.ENVIRONMENT_WALL
  );

  useEffect(() => {
    const hasPassedWall =
      !!appStorage('localStorage')?.getItem('environment-wall');
    setShowWall(isEnvironmentWallEnabled && !hasPassedWall);
  }, [isEnvironmentWallEnabled]);

  const onSubmit = () => {
    if (value?.includes('@rockalingua.com')) {
      appStorage('localStorage')?.setItem('environment-wall', 'passed');
      setShowWall(false);
    } else {
      setValue('');
      notification.error({
        message: 'Error',
        description: 'This is not a Rockalingua employee password',
      });
    }
  };

  return showWall ? (
    <StyledEnvironmentWall
      title={null}
      footer={null}
      closable={false}
      centered
      visible
      width="90vw"
    >
      <div className="title" data-testid="environment-wall-title">
        Warning!
      </div>
      <div>
        This is a TEST environment, only Rockalingua employees can use it.
      </div>
      <div className="text-with-button">
        <span>If you are not a Rockalingua employee, please</span>
        <Button href="https://rockalingua.com" type="primary" size="large">
          Go to Rockalingua.com
        </Button>
      </div>
      <div className="text-with-button">
        <span>If you are, enter your password:</span>
        <Input.Group compact>
          <Input
            size="large"
            onPressEnter={onSubmit}
            className="input"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            data-testid="environment-wall-password-input"
          />
          <Button
            size="large"
            onClick={onSubmit}
            data-testid="environment-wall-continue-button"
          >
            Continue in the TEST environment
          </Button>
        </Input.Group>
      </div>
    </StyledEnvironmentWall>
  ) : null;
}
